import { useEffect } from 'react';
import { useRouter } from 'expo-router';
import { LoadingSpinner } from './LoadingSpinner';

interface OnboardingRouteRedirectProps {
  to: string;
  message?: string;
}

export function OnboardingRouteRedirect({
  to,
  message = 'Taking you to setup...',
}: OnboardingRouteRedirectProps) {
  const router = useRouter();

  useEffect(() => {
    router.replace(to as any);
  }, [router, to]);

  return <LoadingSpinner message={message} />;
}
